//-------------------------------------------------------------------Main server ----------------------------------------------------------------------------------------------------------------------------

export const API_END_POINT = 'https://api.kundaliexpert.com/kmAstroapp/api/v1/'
export const API_END_POINT_NOAUTH = 'https://api.kundaliexpert.com/kmAstroapp/api/v2/'
export const Login_API_END_POINT = 'https://api.kundaliexpert.com/kmAstroapp/auth/login'
export const API_END_POINT_Socket = 'https://api.kundaliexpert.com/kmAstroapp/ws?token='

let TOKEN = 'eyJhbGciOiJIUzI1NiJ9.eyJST0xFIjoiUk9MRV9VU0VSIiwiTE9HSU5fVFlQRSI6ImxvY2FsIiwiVVNFUk5BTUUiOiJLTVNAYXN0cm8iLCJVU0VSX0lEIjozNzYsIklTX0FTVFJPTE9HRVIiOmZhbHNlLCJzdWIiOiIzNzYiLCJpYXQiOjE3NDM2MDI3MjAsImV4cCI6MTgwNjY3NDcyMH0.QAcBmVHCjaBm03L5Cj1UEhkkcJo9hhjXTuvyrP6727g'

export const getToken = () => {
    TOKEN = localStorage.getItem("accessToken");
};
export { TOKEN };


// ------------------------------------------------------------------- Piyush Local --------------------------------------------------------------------------------------------------------------------
//--------------------------------------For Piyush Local Admin Credential scroll down---------------------------------------------

// export const API_END_POINT = 'https://kundalip.springdev.in/api/v1/'
// export const API_END_POINT_NOAUTH = 'https://kundalip.springdev.in/api/v2/'
// export const Login_API_END_POINT = 'http://kundalip.springdev.in/auth/login'
// export const API_END_POINT_Socket = 'https://kundalip.springdev.in/ws?token='
// //User Token
// // let TOKEN = 'eyJhbGciOiJIUzI1NiJ9.eyJST0xFIjoiUk9MRV9VU0VSIiwiTE9HSU5fVFlQRSI6ImxvY2FsIiwiVVNFUk5BTUUiOiI4NDU5NzU3ODY1IiwiVVNFUl9JRCI6MTQyNiwiSVNfQVNUUk9MT0dFUiI6ZmFsc2UsInN1YiI6IjE0MjYiLCJpYXQiOjE3NDM2MDE5NDksImV4cCI6MTgwNjY3Mzk0OX0.Xw2ojH4iMjIb6cdl3xNOF8Lk9hhPrDjmPwhL5xXkDEA'

// //Admin Token
// let TOKEN = 'eyJhbGciOiJIUzI1NiJ9.eyJST0xFIjoiUk9MRV9BU1RST0xPR0VSIiwiTE9HSU5fVFlQRSI6ImxvY2FsIiwiQVNUUk9MT0dFUl9JRCI6MywiVVNFUk5BTUUiOiJrbXNpbmhhQGdtYWlsLmNvbSIsIlVTRVJfSUQiOjM3NiwiSVNfQVNUUk9MT0dFUiI6dHJ1ZSwic3ViIjoiMzc2IiwiaWF0IjoxNzQ2NTMyMTY3LCJleHAiOjE4MDk2MDQxNjd9.2xsBtxqo9jjjJ7c_NKxnAOTV2-HWZcoDxnPLngyhasw'

// export const getToken = () => {
//     TOKEN = localStorage.getItem("accessToken");
// };

// export { TOKEN };




//------------------------------------------------------------------- Localhost:8083 ----------------------------------------------------------------------------------------------------------------------


// export const API_END_POINT = 'http://localhost:8083/api/v1/'
// export const API_END_POINT_NOAUTH = 'http://localhost:8083/api/v2/'
// export const Login_API_END_POINT = 'http://localhost:8083/auth/login'

// //admin token
// // let TOKEN = "eyJhbGciOiJIUzI1NiJ9.eyJST0xFIjoiUk9MRV9VU0VSIiwiTE9HSU5fVFlQRSI6ImxvY2FsIiwiVVNFUk5BTUUiOiJLTVNAYXN0cm8iLCJVU0VSX0lEIjozNzYsIklTX0FTVFJPTE9HRVIiOmZhbHNlLCJzdWIiOiIzNzYiLCJpYXQiOjE3NDM1MDM4NTcsImV4cCI6MTgwNjU3NTg1N30.QmsMu_oGCrLIRhFcMiAUV0wWmJJO3MbAw5vpvoZokk8"

// let TOKEN = localStorage.getItem("accessToken")

// export const getToken = () => {
//     TOKEN = localStorage.getItem("accessToken");
// };

// export { TOKEN };

// //Local Admin Credentials
// //username - admin@gmail.com
// //password - Admin@kundaliexpert



//------------------------------------------------------------------------IP ----------------------------------------------------------------------


//-----------------------------------------------using IP End point --------------------------------------------------------------------------
// export const API_END_POINT = 'http://143.110.184.168:8089/kmAstroapp/api/v1/'
// export const API_END_POINT_NOAUTH = 'http://143.110.184.168:8089/kmAstroapp/api/v2/'
// export const Login_API_END_POINT = 'http://143.110.184.168:8089/kmAstroapp/auth/login'
